import { Flex, forwardRef } from '@chakra-ui/react';

import { createUseVariantStyle } from '@bonusly/ds-hooks';
import { rem } from '@bonusly/ds-utils';

import { useAlertContext } from '../context';

const useVariantStyle = createUseVariantStyle({
	size: {
		sm: {
			py: rem(2),
		},
		md: {
			py: 1,
		},
	},
});

const AlertBody = forwardRef<any, 'div'>((props, ref) => {
	const { size } = useAlertContext();
	const style = useVariantStyle({ size });

	return (
		<Flex
			alignItems="flex-start"
			direction="column"
			flexGrow={1}
			ref={ref}
			sx={{
				'> button:last-of-type': {
					mt: 2,
				},
			}}
			{...style}
			{...props}
		/>
	);
});

AlertBody.displayName = 'AlertBody';

export { AlertBody };
